/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { EntitlementStateModel } from "./EntitlementStateModel";
import type { SponsorshipModel } from "./SponsorshipModel";
import type { VisitType } from "./VisitType";

export interface VisitOptionModel {
  visit_type: VisitType;
  sponsorship?: SponsorshipModel | null;
  entitlement_state: EntitlementStateModel;
}
